import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./component/Header-Footer/Navbar";
import Footer from "./component/Header-Footer/Footer";
import AboutUs from "./component/AboutUs";
import Contact from "./component/Contact";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Career from "./component/Career";
import Internship from "./component/courses/Internship";
import WorkShop from "./component/courses/WorkShop";
import Seminar from "./component/courses/Seminar";
import CorporateTrainings from "./component/courses/CorporateTrainings";

// Pages Start
import Home from "./component/Home";
import OurCourse from "./component/courses/Ourcourse";
import DigitalMarketing from "./component/Service/DigitalMarketing";
import EmbaddedSystem from "./component/Service/EmbaddedSystem";
import IndustrialAutomationService from "./component/Service/IAService";
import ItandSoftware from "./component/Service/ItandSoftware";

// Pages End

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/career" element={<Career />} />

          {/* courses */}
          <Route path="/our-course" element={<OurCourse />} />
          <Route path="/internship" element={<Internship />} />
          <Route path="/workshops" element={<WorkShop />} />
          <Route path="/seminars" element={<Seminar />} />
          <Route path="/corporatetrainings" element={<CorporateTrainings />} />

          {/* Pages */}
          <Route path="/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/embadded-system" element={<EmbaddedSystem />} />
          <Route path="/industrial-automation" element={<IndustrialAutomationService />} />
          <Route path="/it-software" element={<ItandSoftware />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
